import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Scrollbars } from "react-custom-scrollbars";
import ReactHtmlParser from "react-html-parser";
import map from "lodash/map";
import cn from "clsx";

import "./style.scss";

export type DropdownItemProps = { label: string; value: string | number };

const renderTrack = (props, className) => (
  <div {...props} style={{ display: "none" }} className={className} />
);

const Dropdown = ({
  data,
  selectedItem,
  handleChange,
  contentMaxHeight
}: {
  data: DropdownItemProps[];
  selectedItem: DropdownItemProps;
  handleChange: (item: DropdownItemProps) => void;
  contentMaxHeight?: number;
}) => {
  const [isToggle, setIsToggle] = useState<boolean>(false);

  const { t } = useTranslation("checkout");
  const wrapperRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", closeDropdown);

    return () => {
      closeDropdown();
    };
  }, []);

  const handleClickOutside = e => {
    const refWrapper = wrapperRef && !wrapperRef.current?.contains(e.target);

    if (!isToggle && refWrapper) {
      e.stopPropagation();
      setIsToggle(false);
    }
  };

  const closeDropdown = () => {
    if (isToggle) {
      setIsToggle(false);
    }
  };

  const handleOnChange = (item: DropdownItemProps) => {
    setTimeout(() => {
      setIsToggle(false);
    }, 150);

    handleChange(item);
  };

  const handleDropdownToggle = e => {
    e.stopPropagation();

    if (data.length === 0) {
      return false;
    }

    setIsToggle(toggle => !toggle);
  };

  return (
    <div
      ref={wrapperRef}
      className={cn("dropdownContainer", {
        zeroQty: !data?.length,
        filterOpen: isToggle
      })}
      onClick={handleDropdownToggle}
    >
      <div className="dropdownLabelContainer">
        <span>{ReactHtmlParser(selectedItem.label)}</span>
      </div>
      <div className="dropdownModalContainer">
        {isToggle && (
          <div
            className={"showContentContainer"}
            onClick={e => e.stopPropagation()}
          >
            <Scrollbars
              universal
              autoHeight
              autoHeightMin={25}
              autoHeightMax={contentMaxHeight || 250}
              renderTrackHorizontal={props =>
                renderTrack(props, "track-horizontal")
              }
              renderTrackVertical={props =>
                renderTrack(props, "track-vertical")
              }
              className="dropdownScrollSizeContainer"
            >
              {!!data.length ? (
                <ul className="dropdownSizeContentContainer">
                  {map(data, (item, index) => (
                    <li
                      className={cn({
                        selectedValue: selectedItem.value === item.value
                      })}
                      onClick={() => handleOnChange(item)}
                      key={item.value || index}
                    >
                      {ReactHtmlParser(item.label)}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="noDataFound">{t("noDataFound")}</p>
              )}
            </Scrollbars>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
